
import { Link } from 'react-router-dom';
import { useState } from 'react';

const products = [
  {
    id: 1,
    name: 'سيروم فيتامين سي المشرق',
    category: 'العناية بالبشرة',
    price: 299,
    originalPrice: 399,
    rating: 4.9,
    reviews: 234,
    image: 'https://public.readdy.ai/ai/img_res/8cd20fe22cec79b9e9e4b819f2ef3a2d.jpg',
    badge: 'الأكثر مبيعاً',
    badgeColor: 'bg-rose-400'
  },
  {
    id: 2,
    name: 'كريم الترطيب المكثف',
    category: 'العناية بالبشرة',
    price: 249,
    rating: 4.8,
    reviews: 189,
    image: 'https://readdy.ai/api/search-image?query=luxury%20moisturizer%20cream%20jar%20on%20soft%20pink%20background%2C%20elegant%20skincare%20product%20photography%2C%20minimalist%20beauty%20aesthetic%20with%20rose%20petals%2C%20professional%20cosmetic%20display%2C%20feminine%20and%20clean%20style&width=500&height=600&seq=prod2&orientation=portrait',
    badge: 'جديد',
    badgeColor: 'bg-emerald-400'
  },
  {
    id: 3,
    name: 'أحمر شفاه مات طويل الأمد',
    category: 'المكياج',
    price: 149,
    rating: 4.7,
    reviews: 312,
    image: 'https://readdy.ai/api/search-image?query=luxury%20matte%20lipstick%20on%20soft%20pink%20background%2C%20elegant%20makeup%20product%20photography%2C%20minimalist%20beauty%20aesthetic%2C%20professional%20cosmetic%20display%2C%20rose%20gold%20accents%2C%20feminine%20style&width=500&height=600&seq=prod3&orientation=portrait',
    badge: null,
    badgeColor: ''
  },
  {
    id: 4,
    name: 'باليت ظلال العيون الوردية',
    category: 'المكياج',
    price: 329,
    originalPrice: 429,
    rating: 4.9,
    reviews: 267,
    image: 'https://readdy.ai/api/search-image?query=luxury%20pink%20eyeshadow%20palette%20on%20soft%20background%2C%20elegant%20makeup%20product%20photography%2C%20minimalist%20beauty%20aesthetic%2C%20professional%20cosmetic%20display%2C%20rose%20gold%20tones%2C%20feminine%20and%20modern%20style&width=500&height=600&seq=prod4&orientation=portrait',
    badge: 'خصم 23%',
    badgeColor: 'bg-red-400'
  },
  {
    id: 5,
    name: 'لوشن الجسم بالورد',
    category: 'العناية بالجسم',
    price: 199,
    rating: 4.8,
    reviews: 198,
    image: 'https://readdy.ai/api/search-image?query=luxury%20rose%20body%20lotion%20bottle%20on%20soft%20pink%20background%2C%20elegant%20beauty%20product%20photography%2C%20minimalist%20aesthetic%20with%20rose%20petals%2C%20professional%20cosmetic%20display%2C%20feminine%20and%20clean%20style&width=500&height=600&seq=prod5&orientation=portrait',
    badge: null,
    badgeColor: ''
  },
  {
    id: 6,
    name: 'عطر Rose Mist الفاخر',
    category: 'العطور',
    price: 449,
    rating: 5.0,
    reviews: 421,
    image: 'https://readdy.ai/api/search-image?query=luxury%20perfume%20bottle%20with%20pink%20rose%20design%20on%20elegant%20soft%20background%2C%20sophisticated%20fragrance%20photography%2C%20minimalist%20beauty%20aesthetic%2C%20professional%20product%20display%2C%20feminine%20style%20with%20rose%20petals&width=500&height=600&seq=prod6&orientation=portrait',
    badge: 'الأكثر مبيعاً',
    badgeColor: 'bg-rose-400'
  },
  {
    id: 7,
    name: 'ماسك الوجه المنقي',
    category: 'العناية بالبشرة',
    price: 179,
    rating: 4.6,
    reviews: 156,
    image: 'https://readdy.ai/api/search-image?query=luxury%20face%20mask%20jar%20on%20soft%20pink%20background%2C%20elegant%20skincare%20product%20photography%2C%20minimalist%20beauty%20aesthetic%2C%20professional%20cosmetic%20display%2C%20clean%20white%20and%20pink%20tones%2C%20natural%20lighting&width=500&height=600&seq=prod7&orientation=portrait',
    badge: null,
    badgeColor: ''
  },
  {
    id: 8,
    name: 'مجموعة فرش المكياج',
    category: 'أدوات التجميل',
    price: 279,
    originalPrice: 349,
    rating: 4.9,
    reviews: 203,
    image: 'https://readdy.ai/api/search-image?query=luxury%20makeup%20brush%20set%20with%20rose%20gold%20handles%20on%20soft%20pink%20background%2C%20elegant%20beauty%20tools%20photography%2C%20minimalist%20aesthetic%2C%20professional%20product%20display%2C%20feminine%20and%20modern%20style&width=500&height=600&seq=prod8&orientation=portrait',
    badge: 'خصم 20%',
    badgeColor: 'bg-red-400'
  }
];

const BestSellers = () => {
  const [favorites, setFavorites] = useState<number[]>([]);

  const toggleFavorite = (productId: number) => {
    setFavorites(prev =>
      prev.includes(productId)
        ? prev.filter(id => id !== productId)
        : [...prev, productId]
    );
  };

  return (
    <section className="py-20 bg-gradient-to-b from-white to-rose-50/30" dir="rtl">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-800 mb-3" style={{ fontFamily: 'Playfair Display, serif' }}>
            الأكثر مبيعاً
          </h2>
          <p className="text-gray-600">المنتجات المفضلة لدى عملائنا</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((product) => (
            <div
              key={product.id}
              className="group bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300"
              data-product-shop
            >
              <div className="relative overflow-hidden">
                <Link to={`/product/${product.id}`} className="block">
                  <div className="relative w-full h-80 overflow-hidden">
                    <img
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                  </div>
                </Link>
                
                {product.badge && (
                  <span className={`absolute top-3 right-3 ${product.badgeColor} text-white text-xs px-3 py-1.5 rounded-full font-medium`}>
                    {product.badge}
                  </span>
                )}
                
                <button
                  onClick={() => toggleFavorite(product.id)}
                  className="absolute top-3 left-3 w-9 h-9 flex items-center justify-center bg-white rounded-full shadow-md hover:bg-rose-50 transition-colors cursor-pointer"
                >
                  <i className={`${favorites.includes(product.id) ? 'ri-heart-fill text-rose-400' : 'ri-heart-line text-gray-400'} text-lg`}></i>
                </button>
              </div>

              <div className="p-5">
                <p className="text-xs text-rose-400 font-medium mb-2">{product.category}</p>
                <Link to={`/product/${product.id}`}>
                  <h3 className="text-base font-semibold text-gray-800 mb-2 hover:text-rose-400 transition-colors line-clamp-2">
                    {product.name}
                  </h3>
                </Link>
                
                <div className="flex items-center gap-2 mb-3">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-amber-400 text-sm"></i>
                    <span className="text-sm font-medium text-gray-700">{product.rating}</span>
                  </div>
                  <span className="text-xs text-gray-400">({product.reviews} تقييم)</span>
                </div>

                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-2">
                    <span className="text-lg font-bold text-gray-800">{product.price} ر.س</span>
                    {product.originalPrice && (
                      <span className="text-sm text-gray-400 line-through">{product.originalPrice} ر.س</span>
                    )}
                  </div>
                  <button className="w-9 h-9 flex items-center justify-center bg-rose-400 text-white rounded-full hover:bg-rose-500 transition-colors cursor-pointer">
                    <i className="ri-shopping-cart-line text-base"></i>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/shop"
            className="inline-block bg-rose-400 text-white px-10 py-4 rounded-full text-base font-medium hover:bg-rose-500 transition-colors shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            عرض جميع المنتجات
          </Link>
        </div>
      </div>
    </section>
  );
};

export default BestSellers;
